var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FEF0C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5166 17.6853C15.5736 18.2785 15.6702 18.7194 15.803 19.0102C15.9376 19.3002 16.1764 19.4448 16.5212 19.4448C16.5856 19.4448 16.6433 19.4347 16.7005 19.423C16.7591 19.4347 16.8165 19.4448 16.8814 19.4448C17.2252 19.4448 17.4648 19.3002 17.5986 19.0102C17.7322 18.7194 17.8271 18.2785 17.8852 17.6853L18.1913 13.1052C18.2483 12.2124 18.2773 11.5719 18.2773 11.183C18.2773 10.6538 18.1393 10.2409 17.8623 9.94437C17.5843 9.64789 17.2191 9.5 16.7668 9.5C16.7427 9.5 16.7246 9.50539 16.7009 9.50633C16.6784 9.50539 16.6599 9.5 16.6365 9.5C16.1832 9.5 15.8187 9.64789 15.5412 9.94437C15.264 10.2413 15.125 10.6545 15.125 11.1833C15.125 11.5721 15.1534 12.2127 15.2113 13.1054L15.5166 17.6853ZM16.7124 21.1189C16.2732 21.1189 15.9001 21.2574 15.5902 21.5345C15.2806 21.8117 15.1255 22.1483 15.1255 22.5434C15.1255 22.9895 15.2825 23.3405 15.5942 23.5955C15.9073 23.8505 16.2725 23.978 16.6899 23.978C17.1148 23.978 17.4854 23.8524 17.8023 23.6005C18.1187 23.3492 18.2769 22.9963 18.2769 22.5439C18.2769 22.1488 18.1255 21.8122 17.8227 21.5349C17.5198 21.2574 17.1498 21.1189 16.7117 21.1189",
    fill: "#D46B08"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#FFFAEB",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e685a00589e8cb6a76f7f4f4db623d27.svg";
export { ForwardRef as ReactComponent };